import React, { useState } from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import "./TopBar.css";
import logo from "../assets/logoavena.jpg";
import { useAuth } from "../auth/AuthProvider";

export default function TopBar() {
  const [open, setOpen] = useState(false);
  const closeMenu = () => setOpen(false);
  const { authed, logout } = useAuth();
  const navigate = useNavigate();

  const doLogout = () => {
    logout();           // clear in-memory auth
    navigate("/login"); // show login immediately
  };

  return (
    <header className={`topbar ${open ? "is-open" : ""}`}>
      <div className="topbar__inner">
        <Link to="/" className="topbar__brand" onClick={closeMenu}>
          <img src={logo} alt="Avena Admin" className="topbar__logo" />
        </Link>

        <button
          className="topbar__hamburger"
          aria-label="Toggle menu"
          aria-expanded={open ? "true" : "false"}
          onClick={() => setOpen((v) => !v)}
        >
          <span /><span /><span />
        </button>

      <nav className="topbar__nav" role="navigation">
  <NavLink to="/admin/services" className="topbar__link" onClick={closeMenu}>Services</NavLink>
  <NavLink to="/admin/products" className="topbar__link" onClick={closeMenu}>Products</NavLink>
  <NavLink to="/admin/web-solutions" className="topbar__link" onClick={closeMenu}>Web Solutions</NavLink>
  <NavLink to="/admin/team" className="topbar__link" onClick={closeMenu}>Team</NavLink>

  {/* 👉 New menu item */}
  <NavLink to="/admin/clients" className="topbar__link" onClick={closeMenu}>Clients</NavLink>
  
  <NavLink to="/admin/testimonials" className="topbar__link" onClick={closeMenu}>Testimonials</NavLink>
  <NavLink to="/admin/blog" className="topbar__link" onClick={closeMenu}>Blog</NavLink>
  <NavLink to="/admin/event-media" className="topbar__link" onClick={closeMenu}>Events & Media</NavLink>
  <NavLink to="/admin/careers" className="topbar__link" onClick={closeMenu}>Careers</NavLink>
  <NavLink to="/admin/partners" className="topbar__link" onClick={closeMenu}>
  Partners
</NavLink>

  {authed && (
    <button className="topbar__btn" onClick={() => { closeMenu(); doLogout(); }}>
      Logout
    </button>
  )}
</nav>

      </div>
    </header>
  );
}
